import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';
import type { BreadcrumbItem } from '../types';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem as BreadcrumbItemPrimitive,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (!items.length) return null;

  return (
    <Breadcrumb className={cn('text-sm font-sans', className)}>
      <BreadcrumbList>
        {items.map((crumb, index) => {
          const isFirst = index === 0;
          const isLast = index === items.length - 1;
          const clickable = !isFirst && !isLast && Boolean(crumb.href);

          return (
            <React.Fragment key={`${crumb.label}-${index}`}>
              <BreadcrumbItemPrimitive>
                {clickable ? (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.href!}>{crumb.label}</Link>
                  </BreadcrumbLink>
                ) : isLast ? (
                  <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                ) : (
                  <span
                    className={cn(
                      'transition-colors whitespace-nowrap',
                      isFirst && 'text-text-secondary'
                    )}
                  >
                    {crumb.label}
                  </span>
                )}
              </BreadcrumbItemPrimitive>
              {!isLast && <BreadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
